/*! @pentacode/ui v0.1.0 */
import "./icon-DW8BBY5W.js";
import { t as e } from "./styledElement-DUAqv8gi.js";
import { t } from "./css-build-DcREbovZ.js";
import { t as n } from "./decorateMetadata-BXz2gmG4.js";
import { t as r } from "./decorate-C_HUHFGG.js";
import { LitElement as i, html as a, nothing as o } from "lit";
import { customElement as s, property as c } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/file-card/file-card.css.js
var l = t(":host{max-width:100%;display:block}.card{border-radius:var(--radius-default,.5rem);border:1px solid var(--file-card-border-color,#0000001f);background:var(--file-card-bg,#fff);max-width:100%;color:var(--file-card-color,inherit);align-items:center;gap:.5rem;padding:.375rem .75rem;font-size:.9rem;line-height:1.5;display:inline-flex}a.card{cursor:pointer;text-decoration:none;transition:background .15s}a.card:hover{background:var(--file-card-bg-hover,#f2f2f2)}.download-icon{opacity:.6;font-size:.8em}a.card:hover .download-icon{opacity:1}.name{min-width:0;display:flex}.stem{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.ext{white-space:nowrap;flex-shrink:0}ptc-ui-icon{flex-shrink:0}.blocked{cursor:not-allowed}.blocked ptc-ui-icon{color:var(--color-negative)}.uploading{opacity:.7}.uploading ptc-ui-icon{animation:1s steps(8,end) infinite file-card-spin}@media (prefers-reduced-motion:reduce){.uploading ptc-ui-icon{animation:none}}.failed ptc-ui-icon{color:var(--color-negative)}.card:has(.detail){grid-template-columns:auto minmax(0,1fr);row-gap:.125rem;display:inline-grid}.detail{color:var(--color-negative);text-overflow:ellipsis;white-space:nowrap;grid-column:1/-1;font-size:.75em;overflow:hidden}@keyframes file-card-spin{to{transform:rotate(360deg)}}"), u = {
	pdf: "icon.file.pdf",
	txt: "icon.file.plain-text",
	csv: "icon.file.csv",
	xls: "icon.file.spreadsheet",
	xlsx: "icon.file.spreadsheet",
	doc: "icon.file.text",
	docx: "icon.file.text",
	png: "icon.file.image",
	jpg: "icon.file.image",
	jpeg: "icon.file.image",
	webp: "icon.file.image",
	zip: "icon.file.archive"
};
function d(e) {
	return u[e.includes(".") ? e.split(".").pop().toLowerCase() : ""] ?? "icon.file.document";
}
function f(e) {
	let t = e.lastIndexOf(".");
	return t > 0 ? {
		stem: e.slice(0, t),
		extension: e.slice(t)
	} : {
		stem: e,
		extension: ""
	};
}
function p(e) {
	try {
		return new URL(e).protocol === "https:";
	} catch {
		return !1;
	}
}
var m = class extends e(i) {
	constructor(...e) {
		super(...e), this.styles = l, this.name = "", this.url = "", this.detail = "";
	}
	_renderName() {
		let { stem: e, extension: t } = f(this.name);
		return a`<span part="name" class="name"
            ><span class="stem">${e}</span>${t ? a`<span class="ext">${t}</span>` : o}</span
        >`;
	}
	render() {
		return this.status === "uploading" ? a`<div part="card" class="card uploading" title="Datei wird hochgeladen …">
                <ptc-ui-icon part="icon" name="icon.status.loading"></ptc-ui-icon>
                ${this._renderName()}
            </div>` : this.status === "failed" ? a`<div
                part="card"
                class="card failed"
                title=${this.detail || "Upload fehlgeschlagen – bitte Datei erneut auswählen"}
            >
                <ptc-ui-icon part="icon" name="icon.status.warning"></ptc-ui-icon>
                ${this._renderName()}
                ${this.detail ? a`<span part="detail" class="detail">${this.detail}</span>` : o}
            </div>` : this.url ? p(this.url) ? a`<a part="card" class="card" href=${this.url} target="_blank" rel="noopener" title=${this.name}>
            <ptc-ui-icon part="icon" name=${d(this.name)}></ptc-ui-icon>
            ${this._renderName()}
            <ptc-ui-icon part="download-icon" name="icon.action.download" class="download-icon"></ptc-ui-icon>
        </a>` : a`<div part="card" class="card blocked" title="Unsichere Datei – Öffnen blockiert">
                <ptc-ui-icon part="icon" name="icon.status.unsafe"></ptc-ui-icon>
                ${this._renderName()}
            </div>` : a`<div part="card" class="card" title=${this.name}>
                <ptc-ui-icon part="icon" name=${d(this.name)}></ptc-ui-icon>
                ${this._renderName()}
            </div>`;
	}
};
r([c({ type: String }), n("design:type", Object)], m.prototype, "name", void 0), r([c({ type: String }), n("design:type", Object)], m.prototype, "url", void 0), r([c({ type: String }), n("design:type", Object)], m.prototype, "status", void 0), r([c({ type: String }), n("design:type", Object)], m.prototype, "detail", void 0), m = r([s("ptc-ui-file-card")], m);
export { p as n, m as t };

//# sourceMappingURL=file-card-DXmPuWhR.js.map